import React, { Component, ReactNode } from 'react';
import { writeErrorFile } from './logger';

interface State { error: Error | null }
export default class ErrorBoundary extends Component<{children:ReactNode},State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: any) {
    console.error('💥 ErrorBoundary caught:', error, info);
    // write a timestamped log file for this React render error
    writeErrorFile({
      ts: new Date().toISOString(),
      type: 'react-error',
      payload: { message: error.message, stack: error.stack, info },
   });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 20, background: '#fee', color: '#900' }}>
          <h2>Uh oh—something went wrong.</h2>
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error.message}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}